<template>
  <div id='main' class="container d-md-block">
    <div class='row'>
        <div class="col-md-3 d-none d-md-block" style="border-right: 1px solid black;">
            <h6 class='left purple'>{{ $t('Register Your School') }}</h6>
            <h4 id='step1' class='step active left'>{{ $t('Step 1: Find Your School') }}</h4>
            <h4 id='step2' class='step left'>{{ $t('Step 2: Enter your info') }}</h4>
            <h4 id='step3' class='step left'>{{ $t('Step 3: Review and Submit') }}</h4>
        </div>

        <!-- MAIN DIV -->
        <div class="col-md-7" id="accordion">
            <div class="card">
              <div class="card-header d-md-none" id="headingOne">
                  <h5 class="mb-0">
                      <button class="mobile_button btn btn-link collapsed" data-toggle="collapse" data-target="#stepOne" aria-expanded="false" aria-controls="stepOne">
                          <h4 class="mobile_title">{{ $t('Step 1: Find Your School') }}</h4>
                      </button>
                  </h5>
              </div>
              <div id="stepOne" aria-labelledby="headingOne" data-parent="#accordion"> <!-- class="collapse" -->
                <div class="tab card-body2">
                    <label>
                        <h5>{{ $t('Province / Territory') }}</h5></label>
                    <p>
                        <select v-model="province" name="Province"  class='required' @change="onChangeProvince($event)">
                          <option value="">{{ $t('Select one') }}</option>
                          <option v-for="(province, index) in provinces" :key="index" :value="province.id" >{{ province.province }}</option>
                        </select>
                    </p>

                    <div v-if="this.school_error == null">

                      <label>
                        <h5>{{ $t('School Board / Division') }}</h5>
                    </label>
                    <p>
                        <select v-model="school_board" name="SchoolBoard" class='required' @change="onChangeSchoolBoard($event)">
                          <option value="">{{ $t('Select one') }}</option>
                          <option v-for="(school_board, index2) in school_boards" :key="index2" :value="school_board.id" >{{ school_board.name }}</option>
                        </select>
                        <small v-if="prov_short != 'YT' && prov_short != ''">{{ $t('If you are an independent school, please select the option “Independent and Other” from the menu') }}</small>
                    </p>
                    
                      <label>
                          <h5>{{ $t('School Name') }}</h5>
                      </label>
                          <p>
                          <select v-model="school_name" class='required' name="SchoolName" @change="onChangeSchool($event)">
                            <option value="">{{ $t('Select one') }}</option>
                            <option v-for="(school, index3) in schools" :key="index3" :value="school.id" >{{ school.name }}</option>
                          </select>
                          <small v-html="$t('If you cannot find your school in the list, please contact us at 1-866-488-8775 or hello@civix.ca')"></small>
                      </p>
                    </div>
                    <div v-else>
                      <span v-html="this.school_error"></span>
                    </div>
                    <div v-if="this.school_error == null && this.province_string != ''">
                      <label>
                          <h5>{{ $t('How did you hear about Student Vote Canada 2019?' + this.prov_short, {election_name: this.province_string}) }}</h5>
                      </label>
                      <p>
                          <select name="reference" v-model="reference" oninput="this.className = ''"  >
                              <option value="" disabled selected>{{ $t('Select one') }}</option>
                              <optgroup v-if="(index != 'Other')" v-for="(a_reference, index) in references" :key="index" v-bind:label="index">
                                <option v-for="(a_reference2, index2) in a_reference" :key="index2" :value="a_reference2" >{{ a_reference2 }}</option>
                              </optgroup>
                              <option v-else v-for="(a_reference2, index2) in a_reference" :key="index2" :value="a_reference2" >{{ a_reference2 }}</option>


                          </select>
                      </p>
                      <div v-if="reference === 'Other' || reference === 'Autre (veuillez préciser)'">
                        {{ $t('Please describe:') }} <input type="text" name="HeardAboutProgramOther" size="24" v-model='heard_program_other'/>
                      </div>
                    </div>
                </div>
              </div>
              <div v-if="this.currentTab == 0 && this.school_error == null" style="overflow:auto;">
                <div style="float:right;">
                    <button type="button" @click="nextPrev(1)">{{ $t('Next') }}</button>
                </div>
              </div>

            </div>

            <div class="card">
              <div class="card-header d-md-none" id="headingTwo">
                  <h5 class="mb-0">
                      <button class="mobile_button btn btn-link collapsed" data-toggle="collapse" data-target="#stepTwo" aria-expanded="false" aria-controls="stepTwo">
                          <h4 class='mobile_title'>{{ $t('Step 2: Enter your info') }}</h4>
                        </button>
                  </h5>
              </div>
              <div id="stepTwo" aria-labelledby="headingTwo" data-parent="#accordion"> <!-- class="collapse" -->
                <div class="tab card-body2">
                  <div class="row">
                      <div class="col-lg-12">
                          <h2>{{ $t('Contact Information') }}</h2>
                      </div>
                      
                      <div class="col-lg-12" v-if="school_info">
                          <span class='school'>{{ school_info.school_name }}</span><br />
                          <span class='school'>{{ school_info.address_1 }}</span><br />
                          <span v-if="school_info.address_2.length > 0"><span class='school'>{{ school_info.address_2 }}</span><br /></span>
                          <span class='school'>{{ school_info.city }}, {{ school_info.province }}, {{ school_info.postal_code }}</span><br /><br />
                          <p><a href='#' @click='nextPrev(-1)'>{{ $t('click_here_to_go_back')}}</a></p>
                      </div>

                      <div class="col-lg-6" id="been_team_lead">
                          <p class='left'>
                              <label>
                                  <h5>{{ $t('Have you been a Student Vote Team Leader before?') }}</h5>
                              </label><br />
                              <input type="radio" class='required' name="teamleader" :value="$t('Yes')" v-model="been_team_lead"> {{ $t('Yes') }}
                              <br>
                              <input type="radio"  class='required' name="teamleader" :value="$t('not team leader')" v-model="been_team_lead"> {{ $t('not team leader') }}
                              <br>
                              <input type="radio"  class='required' name="teamleader" :value="$t('No')" v-model="been_team_lead"> {{ $t('No') }}
                              <br>

                              <input type="radio"  class='required' name="teamleader" :value="$t('cant remember')" v-model="been_team_lead"> {{ $t("I can't remember") }}
                              <br>
                          </p>
                      </div>

                      <div class="col-lg-6" id="involvement">
                          <p v-if="been_team_lead === 'Yes' || been_team_lead === 'Oui'" class='left'>
                              <label>
                                  <h5>{{ $t('How many Student Vote programs have you been involved with?') }}</h5>
                              </label><br />
                              <input type="radio"  class='required' name="involvment" value="1" v-model="involvment"> {{ $t('1 election') }}
                              <br>
                              <input type="radio" class='required' name="involvment" value="2" v-model="involvment"> {{ $t('2 elections') }}
                              <br>
                              <input type="radio" class='required' name="involvment" value="3" v-model="involvment"> {{ $t('3 elections') }}
                              <br>
                              <input type="radio" class='required' name="involvment" value="4" v-model="involvment"> {{ $t('4 or more') }}
                              <br>
                          </p>
                      </div>

                      <div class="col-lg-6">
                          <label>
                              <h5>{{ $t('First Name') }}</h5>
                          </label><br />
                          <p>
                              <input class='required' v-bind:placeholder="$t('First Name')" v-model="tl_first_name" oninput="this.className = ''" name="fname">
                          </p>
                      </div>

                      <div class="col-lg-6">
                          <label>
                              <h5>{{ $t('Last Name') }}</h5></label><br />
                          <p>
                              <input class='required' v-bind:placeholder="$t('Last Name')" v-model="tl_last_name" oninput="this.className = ''" name="lname">
                          </p>
                      </div>

                      <div class="col-lg-6">
                          <label>
                              <h5>{{ $t('School E-mail address') }}</h5></label><br />
                          <p>
                              <input class='required' v-bind:placeholder="$t('Email Address')" v-model="tl_email" oninput="this.className = ''" name="email">
                          </p>
                      </div>

                      <div class="col-lg-6">
                          <label>
                              <h5>{{ $t('Confirm E-mail address') }}</h5></label><br />
                          <p>
                              <input class='required' v-bind:placeholder="$t('Re-enter your email')" v-model="tl_confirm_email" oninput="this.className = ''" name="confirm email">
                          </p>
                      </div>

                      <div class="col-lg-6">
                          <label>
                              <h5>{{ $t('School phone') }}</h5></label><br />
                          <p>
                              <input class='required' placeholder="555-555-5555" v-model="tl_phone" oninput="this.className = ''" name="school phone">
                          </p>
                          <small>{{ $t('Please use format 555-555-5555') }}</small>
                      </div>

                      <div class="col-lg-6" id="language_correspondence">
                          <p class='left'>
                              <label>
                                  <h5>{{ $t('Language of correspondence') }}</h5>
                              </label><br />
                              <input class='required' type="radio" name="language" :value="$t('FR_English')" v-model="language_correspondence"> {{ $t('English') }}
                              <br>
                              <input class='required' type="radio" name="language" :value="$t('French')" v-model="language_correspondence"> {{ $t('French') }}
                              <br>
                          </p>
                      </div>

                      <div class="col-lg-12" v-if="election_type == 'Federal'">
                          <br />
                          <label>
                              <h5>{{ $t('How would you like to receive information about resources and updates to', {election_name: this.province_string}) }}</h5>
                          </label><br />
                          <small>{{ $t('Select all that apply') }}</small>
                          <p>
                              <input type='checkbox' v-model="receive_info" :value="$t('Email')" />&nbsp;{{ $t('Email') }} <br />
                              <input type='checkbox' v-model="receive_info" :value="$t('Text message')"/>&nbsp;{{ $t('Text message (please ensure number above corresponds to a mobile phone)') }} <br />
                              <input type='checkbox' v-model="receive_info" :value="$t('Phone call')"/>&nbsp;{{ $t('Phone call') }} <br />
                          </p>
                      </div>
                      
                      <div v-if="election_type == 'Federal'" class="col-lg-12 subhead">
                          {{ $t('Secondary contact details') }}
                      </div>
                      <div v-if="election_type == 'Federal'" class="col-lg-12">
                        <small>{{ $t('This section is optional or can be added at a later date') }}</small>
                      </div><br /><br />

                      <div v-if="election_type == 'Federal'" class="col-lg-6">
                          <label>
                              <h5>{{ $t('First Name') }}</h5></label><br />
                          <p>
                              <input v-bind:placeholder="$t('First Name')" v-model="sec_tl_first_name" oninput="this.className = ''" name="fname">
                          </p>
                      </div>

                      <div v-if="election_type == 'Federal'" class="col-lg-6">
                          <label>
                              <h5>{{ $t('Last Name') }}</h5></label><br />
                          <p>
                              <input v-bind:placeholder="$t('Last Name')" v-model="sec_tl_last_name" oninput="this.className = ''" name="lname">
                          </p>
                      </div>

                      <div v-if="election_type == 'Federal'" class="col-lg-6">
                          <label>
                              <h5>{{ $t('School E-mail address') }}</h5></label><br />
                          <p>
                              <input v-bind:placeholder="$t('Email Address')" v-model="sec_tl_email" oninput="this.className = ''" name="email">
                          </p>
                      </div>

                      <div v-if="election_type == 'Federal'" class="col-lg-6">
                          <label>
                              <h5>{{ $t('Confirm E-mail address') }}</h5></label><br />
                          <p>
                              <input v-bind:placeholder="$t('Re-enter your email')" v-model="sec_tl_confirm_email" oninput="this.className = ''" name="confirm email">
                          </p>
                      </div>

                      <div v-if="election_type == 'Federal'" class="col-lg-6" id="sec_language_correspondence">
                          <p class='left'>
                              <label>
                                  <h5>{{ $t('Language of correspondence') }}</h5>
                              </label><br />
                              <input type="radio" name="sec_language" :value="$t('FR_English')" v-model="sec_language_correspondence"> {{ $t('English') }}
                              <br>
                              <input type="radio" name="sec_language" :value="$t('French')" v-model="sec_language_correspondence"> {{ $t('French') }}
                              <br>
                          </p>
                      </div>

                      <div class="col-lg-12 padding-12">
                          <h2>{{ $t('School information') }}</h2>
                      </div>

                      <div class="col-lg-6">
                          <label>
                              <h5>{{ $t('School type') }}</h5></label><br />
                          <p>
                              <select class='required' name="school_type"  v-model="school_type">
                                <option value="">{{ $t('Select one') }}</option>
                                <option v-for="(a_school_type, index) in school_types" :key="index" :value="a_school_type.school_type" >{{ a_school_type.school_type }}</option>
                              </select>
                          </p>
                      </div>

                      <div class="col-lg-6">
                          <label>
                              <h5 v-if="prov_short != 'YT'">{{ $t('Number of Ballots') }}</h5>
                              <h5 v-else-if="prov_short == 'YT'">{{ $t('Number of Students') }}</h5>
                            </label><br />
                          <p>
                              <input class='required' v-bind:placeholder="$t('Enter a number')" v-model="ballots" oninput="this.className = ''" name="ballots" id="num_ballots">
                          </p>
                      </div>

                      <div class="col-lg-6">
                          <label>
                              <h5>{{ $t('Grades to be involved') }}</h5>
                          </label><br />
                          <small>{{ $t('Select all that apply. Hold down the Ctrl (windows) / Command (Mac) button to select multiple options.') }}</small>
                          <p>
                              <select name="grades"  multiple="true" v-model="grade_list" class='select-navigation required' size="4">
                                <optgroup></optgroup>
                                <option v-for="(a_grade, index) in grades" :key="index" :value="$t(a_grade)" >{{ $t(a_grade) }}</option>
                              </select>
                          </p>
                      </div>

                      <div class="col-lg-6">
                          <p class='left'>
                              <label>
                                  <h5>{{ $t('Do you require ballot boxes and voting screens?') }}</h5>
                              </label><br />
                              <select class='required' name="requireballot" v-model="requireballot"  tabindex="23">
                                <option value="" selected="selected">{{ $t('Please select') }}</option>
                                <option :value="$t('Yes')"  >{{ $t('Yes') }}</option>
                                <option :value="$t('No, I saved mine from the last Student Vote Program')"  >{{ $t('No, I saved mine from the last Student Vote Program') }}</option>
                              </select>
                          </p>
                      </div>

                      <div v-if="prov_short != 'YT' && prov_short != 'PE'" class="col-lg-6" id='resource_type'>
                              <label>
                                  <h5>{{ $t('Resource Type') }}</h5>
                              </label>
                                <div v-for="(aresourcetype, index) in resource_types" :key="index">
                                  <input :value="aresourcetype.resource_type_id" class='required' type="radio" name="resourcetype"  v-model="resourcetype" @click="updateResourceName($event)" /> {{ aresourcetype.resource_type_name }} 
                                </div><br />
                      </div>

                      <div class="col-lg-6" v-if="election_id != '55'">
                          <label>
                              <h5>{{ $t('Federal Riding' + this.election_type + this.prov_short) }}</h5></label><br />
                          <p>
                              <select class='required' name="riding"  v-model="riding" @change="onChangeRiding($event)">
                                <option value="">{{ $t('Select one') }}</option>
                                <option v-for="(district, index) in districts" :key="index" :value="district.district_id" >{{ district.district_name }}</option>
                              </select>
                              <small v-if="this.election_type == 'Federal'"><a :href="this.riding_link" target="_blank">{{ $t('If you’re not sure what your riding is, click this link to Find Your Riding') }}</a></small>
                              <small v-else-if="this.election_type != 'Federal' && this.prov_short != null && this.prov_short != 'NS' && this.prov_short != 'NL'"><a :href="this.riding_link" target="_blank">{{ $t('If you’re not sure what your riding is, click this link to Find Your Riding' + this.prov_short) }}</a></small>
                          </p>
                          <small v-if="this.election_type != 'Municipal' && this.prov_short != 'ON' && this.prov_short != 'NB' && this.prov_short != 'SK' && this.prov_short != 'NS' && this.prov_short != 'YT' && this.prov_short != 'AB'"><a :href="this.riding_link" target="_blank">{{ $t('Click here to find your 2024 electoral district') }}</a></small>
                      </div>


                      <div class="col-lg-6" id="languagematerials" v-if="prov_short != 'PE'">
                              <label>
                                  <h5>{{ $t('Language of Resources') }}</h5>
                              </label>
                              <div>
                              <input class='required' type="radio" name="languagematerials" :value="$t('English')" v-model="languagematerials" /> {{ $t('English') }}
                              </div>
                              <div>
                              <input class='required' type="radio" name="languagematerials" :value="$t('French')" v-model="languagematerials" /> {{ $t('French') }}
                              </div>
                              <div>
                              <input class='required' type="radio" name="languagematerials" :value="$t('Both')" v-model="languagematerials" /> {{ $t('Both') }}
                              </div>
                      </div>

                      <div v-if="this.election_type == 'Municipal' && this.prov_short != 'AB' && this.prov_short != 'NB' && this.prov_short != 'NL' && this.prov_short != 'BC' && this.prov_short != 'NS' && this.prov_short != 'ON' && this.prov_short != 'MB'" class="col-lg-6">
                          <label>
                              <h5>{{ $t('School District Sub-district' + this.prov_short) }}</h5></label><br />
                          <p>
                              <select class='required' name="subdistrict"  v-model="subdistrict" @change="onChangeSubdistrict($event)">
                                <option value="">{{ $t('Select one') }}</option>
                                <option v-for="(subdistrict, index) in subdistricts" :key="index" :value="subdistrict.subdistrict_id" >{{ subdistrict.name }}</option>
                              </select>
                          </p>
                      </div>
                  </div>
                </div>
              </div>
              
              <div v-if="this.currentTab == 1" style="overflow:auto;">
                <div style="float:right;">
                    <button type="button" class='prevBtn' @click="nextPrev(-1)">{{ $t('Previous') }}</button>
                    <button type="button" @click="nextPrev(1)">{{ $t('Next') }}</button>
                </div>
              </div>

            </div>

            <div class="card">
                <div class="card-header d-md-none" id="headingThree">
                    <h5 class="mb-0">
                        <button class="mobile_button btn btn-link collapsed" data-toggle="collapse" data-target="#headingThree" aria-expanded="false" aria-controls="headingThree">
                            <h4 class='mobile_title'>{{ $t('Step 3: Review and Submit') }}</h4>
                          </button>
                    </h5>
                </div>
                <div id="stepThree" aria-labelledby="headingThree" data-parent="#accordion"> <!-- class="collapse" -->
                  <div class="tab card-body2">
                      <div class="row">
                        <div class="col-lg-12">
                            <h2>{{ $t('Contact Information') }}</h2>
                        </div>

                        <div class="col-lg-12" v-if="school_info">
                          <span class='school'>{{ school_info.school_name }}</span><br />
                          <span class='school'>{{ school_info.address_1 }}</span><br />
                          <!-- <span class='school' v-if="school_info.address_2.length > 0">{{ school_info.address_2 }}</span><br /> -->
                          <span v-if="school_info.address_2.length > 0"><span class='school'>{{ school_info.address_2 }}</span><br /></span>
                          <span class='school'>{{ school_info.city }}, {{ school_info.province }}, {{ school_info.postal_code }}</span><br /><br />
                          <p><a href='#' @click='nextPrev(-1)'>{{ $t('click_here_to_go_back')}}</a></p>
                      </div>

                        <div class="col-lg-6">
                            <p>
                                <label>
                                    <h5>{{ $t('Have you been a Student Vote Team Leader before?') }}</h5>
                                </label><br />
                                  {{ been_team_lead }}
                            </p>
                        </div>

                        <div class="col-lg-6">
                            <p v-if="been_team_lead === 'Yes' || been_team_lead === 'Oui'">
                                <label>
                                    <h5>{{ $t('How many Student Vote programs have you been involved with?') }}</h5>
                                </label><br />
                                  {{ involvment }}
                            </p>
                        </div>

                        <div class="col-lg-6">
                            <label>
                              <h5>{{ $t('First Name') }}</h5>
                            </label><br />
                            <p>
                                  {{ tl_first_name }}
                            </p>
                        </div>

                        <div class="col-lg-6">
                            <label>
                                <h5>{{ $t('Last Name') }}</h5></label><br />
                            <p>
                                  {{ tl_last_name }}
                            </p>
                        </div>

                        <div class="col-lg-6">
                            <label>
                                <h5>{{ $t('School E-mail address') }}</h5></label><br />
                            <p>
                                  {{ tl_email }}
                            </p>
                        </div>

                        <div class="col-lg-6">
                            <label>
                                <h5>{{ $t('School phone') }}</h5></label><br />
                            <p>
                                  {{ tl_phone }}
                            </p>
                        </div>

                        <div class="col-lg-6">
                            <p>
                                <label>
                                    <h5>{{ $t('Language of correspondence') }}</h5>
                                </label><br />
                                  {{ language_correspondence }}
                            </p>
                        </div>

                        <div class="col-lg-12" v-if="election_type == 'Federal'">
                          <br />
                          <label>
                              <h5>{{ $t('How would you like to receive information about resources and updates to', {election_name: this.province_string}) }}</h5></label><br />
                          <p>
                              {{ receive_info.join(", ") }}
                          </p>
                      </div>

                        <div v-if="election_type == 'Federal'" class="col-lg-12 subhead">
                            {{ $t('Secondary contact details') }}
                          </div>

                        <div v-if="election_type == 'Federal'" class="col-lg-6">
                            <label>
                                <h5>{{ $t('First Name') }}</h5></label><br />
                            <p>
                                  {{ sec_tl_first_name.length == "" ? "N/A" : sec_tl_first_name }}
                            </p>
                        </div>

                        <div v-if="election_type == 'Federal'" class="col-lg-6">
                            <label>
                                <h5>{{ $t('Last Name') }}</h5></label><br />
                            <p>
                                  {{ sec_tl_last_name.length == "" ? "N/A" : sec_tl_last_name }}
                            </p>
                        </div>

                        <div v-if="election_type == 'Federal'" class="col-lg-6">
                            <label>
                                <h5>{{ $t('School E-mail address') }}</h5></label><br />
                            <p>
                                  {{ sec_tl_email.length == "" ? "N/A" : sec_tl_email }}
                            </p>
                        </div>

                        <div v-if="election_type == 'Federal'" class="col-lg-6">
                            <label>
                                <h5>{{ $t('Language of correspondence') }}</h5></label><br />
                            <p>
                                  {{ sec_language_correspondence.length == "" ? "N/A" : sec_language_correspondence }}
                            </p>
                        </div>

                        <div class="col-lg-12">
                            <h2>{{ $t('School information') }}</h2>
                        </div>

                        <div class="col-lg-6">
                            <label>
                                <h5>{{ $t('School type') }}</h5></label><br />
                            <p>
                                  {{ school_type }}
                            </p>
                        </div>

                        <div class="col-lg-6">
                            <label>
                              <h5 v-if="prov_short != 'YT'">{{ $t('Number of Ballots') }}</h5>
                              <h5 v-else-if="prov_short == 'YT'">{{ $t('Number of Students') }}</h5>
                            </label><br />
                            
                            <p>
                                  {{ ballots }}
                            </p>
                        </div>

                        <div class="col-lg-6">
                            <label>
                                <h5>{{ $t('Grades to be involved') }}</h5></label><br />
                            <p>
                                  {{ grade_list.join(",") }}
                            </p>
                        </div>

                        <div class="col-lg-6">
                                <label>
                                    <h5>{{ $t('Do you require ballot boxes and voting screens?') }}</h5>
                                </label><br />
                                <p>
                                  {{ requireballot }}
                            </p>
                        </div>
                        
                        <div v-if="prov_short != 'YT' && prov_short != 'PE'" class="col-lg-6">
                                <label>
                                    <h5>{{ $t('Resource Type') }}</h5>
                                </label><br />
                                <p>
                                  {{ resourcetypename }}
                            </p>
                        </div>


                        <div class="col-lg-6" v-if="election_id != '55'">
                            <label>
                                <h5>{{ $t('Federal Riding' + this.election_type + this.prov_short) }}</h5></label><br />
                            <p>
                                  {{ riding_name }}
                            </p>
                        </div>


                        <div class="col-lg-6" v-if="prov_short != 'PE'">
                            <label>
                                <h5>{{ $t('Language of Resources') }}</h5></label><br />
                            <p>
                                  {{ languagematerials }}
                            </p>
                        </div>

                         <div v-if="this.election_type == 'Municipal' && this.prov_short != 'AB' && this.prov_short != 'NB' && this.prov_short != 'NL'  && this.prov_short != 'BC' && this.prov_short != 'ON' && this.prov_short != 'MB' && this.prov_short != 'NS'" class="col-lg-6">
                            <label>
                                <h5>{{ $t('School District Sub-district' + this.prov_short) }}</h5></label><br />
                            <p>
                                  {{ subdistrict_name }}
                            </p>
                        </div>
                    </div>
                  </div>
                </div>
                <div v-if="this.currentTab == 2" style="overflow:auto;">
                  <div style="float:right;">
                      <button type="button" class='prevBtn' @click="nextPrev(-1)">{{ $t('Previous') }}</button>
                      <button type="button" @click="nextPrev(1)">{{ $t('Submit') }}</button>
                  </div>
                </div>
              </div>

            <!-- <div v-if="this.school_error == null" style="overflow:auto;">
                <div style="float:right;">
                    <button type="button" id="prevBtn" @click="nextPrev(-1)">{{ $t('Previous') }}</button>
                    <button type="button" id="nextBtn" @click="nextPrev(1)">{{ $t('Next') }}</button>
                </div>
            </div> -->
            <!-- Circles which indicates the steps of the form: -->
            <div style="text-align:center;margin-top:40px;">
                <span class="step"></span>
                <span class="step"></span>
                <span class="step"></span>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Registration",
  data: function () {
    return {
      school_info: null,
      school_error: null,
      requireballot: "",
      grade_list: [],
      election_id: -1,
      references: [],
      districts: [],
      school_types: [],
      resource_types: [],
      subjects: [],
      provinces: [],
      school_boards: [],
      schools: [],
      school_board: "",
      school: -1,
      heard_program_other: "",
      province: "",
      school_name: "",
      reference: "",
      been_team_lead: "",
      tl_first_name: "",
      tl_last_name: "",
      tl_email: "",
      tl_confirm_email: "",
      tl_phone: "",
      tl_before: "",
      involvment: "",
      language_correspondence: "",
      sec_language_correspondence: "",
      sec_tl_first_name: "",
      sec_tl_last_name: "",
      sec_tl_email: "",
      sec_tl_confirm_email: "",
      school_type: "",
      resourcetype: "",
      resourcetypename: "",
      riding: "",
      riding_name: "",
      ballots: "",
      languagematerials: "",
      currentTab: 0,
      currentDupe: 0,
      school_board_error: null,
      civix: false,
      province_string: "",
      prov_short: "",
      election_type: null,
      riding_link: null,
      subdistricts: [],
      subdistrict: "",
      subdistrict_name: "",
      receive_info: []
    };
  },
  props: {
    dupe: Number,
    provinceSlug: String,
    electionTypeSlug: String,
  },
  mounted: function () {
    // console.log(this.$LANG);
    this.showTab(this.currentTab); // Display the current tab

    if (this.$router.currentRoute.fullPath.includes("/?civix=true")) {
      this.civix = true;
    }
  },
  beforeMount() {
    this.getProvinces();
    this.grades = [
      "ALL",
      "NONE",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ];

    if (this.dupe && this.dupe == 1) {
      this.currentDupe = 1;

      this.getDistricts(this.province, this.election_id);
      this.getResourceTypes(this.election_id);
      this.getSchoolTypes(this.election_id);
    }
  },
  methods: {
    updateResourceName(event) {
      let value = event.target.value;
      for (var i = 0; i < this.resource_types.length; i++) {
        var res = this.resource_types[i];
        if (res.resource_type_id === value) {
          this.resourcetypename = res.resource_type_name;
          break;
        }
      }
    },
    onChangeRiding(event) {
      let value = event.target.value;
      for (var i = 0; i < this.districts.length; i++) {
        var dist = this.districts[i];
        if (dist.district_id === value) {
          this.riding_name = dist.district_name;
          break;
        }
      }
    },
    onChangeSubdistrict(event) {
      let value = event.target.value;
      for (var i = 0; i < this.subdistricts.length; i++) {
        var dist = this.subdistricts[i];
        if (dist.subdistrict_id === value) {
          this.subdistrict_name = dist.name;
          break;
        }
      }
    },
    onChangeProvince(event) {
      let value = event.target.value;
      this.province = value;
      console.log(this.province);
      if (value == 2) {
        this.grades = [
          "ALL",
          "NONE",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7 / Sec I",
          "8 / Sec II",
          "9 / Sec III",
          "10 / Sec IV",
          "11 / Sec V",
          "12",
          "Cégep",
        ];
      } else {
        this.grades = [
          "ALL",
          "NONE",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ];
      }

      this.getSchoolBoards(value, this.electionTypeSlug);
    },
    onChangeSchool(event) {
      let value = event.target.value;
      this.school = value;
      // this.getSchools(value);
      this.getDistricts(this.province, this.election_id);
      this.getResourceTypes(this.election_id);
      this.getSchoolTypes(this.election_id);
      this.getSchoolInfo(this.school);
    },
    onChangeSchoolBoard(event) {
      let value = event.target.value;
      this.school_board = value;
      this.getSchools(value);
      this.getSubdistricts(value);
    },
    checkRegistration(callback) {
      let url = this.$API + "/check_registration";

      var payload = {
        election_id: this.election_id,
        school: this.school,
        dupe: this.currentDupe,
      };

      fetch(url, {
        method: "POST",
        body: JSON.stringify(payload),
        //headers: new Headers({
        //  'x-api-key': this.$TOKEN
        //})
      })
        .then((stream) => stream.json())
        .then((response) => {
          console.log("response");
          console.log(response);
          if (callback != null) {
            callback(response);
          }
        })
        .catch((error) => {
          console.log("Error " + error);

          this.isLoading = false;
          //console.log('ERROR getTableData: '+error)
        });
    },
    getReferences(province_id, election_id) {
      let url = this.$API + "/get_reference/" + province_id + "/" + election_id;
      fetch(url, {
        method: "GET",
        //headers: new Headers({
        //  'x-api-key': this.$TOKEN
        //})
      })
        .then((stream) => stream.json())
        .then((response) => {
          if (response.error) {
            //console.log("error");
          } else {
            //console.log(response);
            this.references = response;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          //console.log('ERROR getTableData: '+error)
        });
    },
    getProvinces() {
      let url = this.$API + "/get_provinces/" + this.$LANG;
      fetch(url, {
        method: "GET",
        //headers: new Headers({
        //  'x-api-key': this.$TOKEN
        //})
      })
        .then((stream) => stream.json())
        .then((response) => {
          if (response.error) {
            //console.log("error");
          } else {
            //console.log(response);
            this.provinces = response;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          //console.log('ERROR getTableData: '+error)
        });
    },
    getSchoolBoards(province, electionType) {
      let url = this.$API + "/load_school_boards/" + province;
      let queryParams = [];
      if (this.civix == true) {
        queryParams.push("civix=true");
      }
      if (electionType) {
        url = url + "/" + electionType;
      }
      if (queryParams.length > 0) {
        url += "?" + queryParams.join("&");
      }

      let self = this;
      fetch(url, {
        method: "GET",
        //headers: new Headers({
        //  'x-api-key': this.$TOKEN
        //})
      })
        .then((stream) => stream.json())
        .then((response) => {
          if (response.error != null) {
            this.school_error = response.error;
          } else {
            //console.log(response);
            this.election_id = response.election_id;
            this.school_boards = response.school_boards;
            this.province_string = response.election_name;
            this.prov_short = response.prov_short;
            this.election_type = response.election_type;
            this.riding_link = response.electoral_link;

            if (this.$i18n.locale == "fr") {
              this.riding_link = response.french_link;
            }

            this.getReferences(this.province, response.election_id);
          }
        })
        .catch((error) => {
          console.log("here " + error);
          //console.log('ERROR getTableData: '+error)
        });
    },
    getSchools(school_board) {
      let url = this.$API + "/load_schools/" + school_board;
      fetch(url, {
        method: "GET",
        //headers: new Headers({
        //  'x-api-key': this.$TOKEN
        //})
      })
        .then((stream) => stream.json())
        .then((response) => {
          if (response.error) {
            this.school_error = response.error;
          } else {
            this.school_error = null;
            this.schools = response.schools;
          }
        })
        .catch((error) => {});
    },
    getDistricts(province, election_id) {
      let url = this.$API + "/get_districts/" + election_id + "/" + province;
      fetch(url, {
        method: "GET",
        //headers: new Headers({
        //  'x-api-key': this.$TOKEN
        //})
      })
        .then((stream) => stream.json())
        .then((response) => {
          if (response.error) {
            //console.log("error");
          } else {
            //console.log(response);
            this.districts = response;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          //console.log('ERROR getTableData: '+error)
        });
    },
    getSubjects(election_id) {
      let url = this.$API + "/get_subjects_taught/" + election_id;
      fetch(url, {
        method: "GET",
        //headers: new Headers({
        //  'x-api-key': this.$TOKEN
        //})
      })
        .then((stream) => stream.json())
        .then((response) => {
          if (response.error) {
            //console.log("error");
          } else {
            //console.log(response);
            this.subjects = response.schools;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          //console.log('ERROR getTableData: '+error)
        });
    },
    getResourceTypes(election_id) {
      let url = this.$API + "/get_resource_types/" + election_id;
      fetch(url, {
        method: "GET",
        //headers: new Headers({
        //  'x-api-key': this.$TOKEN
        //})
      })
        .then((stream) => stream.json())
        .then((response) => {
          if (response.error) {
            //console.log("error");
          } else {
            //console.log(response);
            this.resource_types = response;
            // this.resourcetype = response[0].resource_type_id;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          //console.log('ERROR getTableData: '+error)
        });
    },
    getSchoolTypes(election_id) {
      let url = this.$API + "/get_school_types/" + election_id;
      fetch(url, {
        method: "GET",
        //headers: new Headers({
        //  'x-api-key': this.$TOKEN
        //})
      })
        .then((stream) => stream.json())
        .then((response) => {
          if (response.error) {
            //console.log("error");
          } else {
            //console.log(response);
            this.school_types = response;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          //console.log('ERROR getTableData: '+error)
        });
    },
    getSubdistricts(board_id) {
      let url =
        this.$API +
        "/get_subdistricts/" +
        this.election_id +
        "/" +
        board_id +
        "/" +
        this.province;
      fetch(url, {
        method: "GET",
        //headers: new Headers({
        //  'x-api-key': this.$TOKEN
        //})
      })
        .then((stream) => stream.json())
        .then((response) => {
          if (response.error) {
            this.school_error = response.error;
          } else {
            this.school_error = null;
            this.subdistricts = response;
          }
        })
        .catch((error) => {});
    },
    getSchoolInfo(school) {
      let url = this.$API + "/get_school_address/" + school;
      fetch(url, {
        method: "GET",
        //headers: new Headers({
        //  'x-api-key': this.$TOKEN
        //})
      })
        .then((stream) => stream.json())
        .then((response) => {
          if (response.error) {
            this.school_error = response.error;
          } else {
            this.school_error = null;
            this.school_info = response;
          }
        })
        .catch((error) => {});
    },
    submitRegistration(callback) {
      let url = this.$API + "/submit_registration";

      if (this.election_id == '55') {
        this.riding = 1;
      }

      var payload = {
        election_id: this.election_id,
        school_board: this.school_board,
        school: this.school,
        heard_program_other: this.heard_program_other,
        province: this.province,
        school_name: this.school_name,
        reference: this.reference,
        been_team_lead: this.been_team_lead,
        tl_first_name: this.tl_first_name,
        tl_last_name: this.tl_last_name,
        tl_email: this.tl_email,
        tl_phone: this.tl_phone,
        tl_before: this.tl_before,
        involvment: this.involvment,
        language_correspondence: this.language_correspondence,
        sec_language_correspondence: this.sec_language_correspondence,
        sec_tl_first_name: this.sec_tl_first_name,
        sec_tl_last_name: this.sec_tl_last_name,
        sec_tl_email: this.sec_tl_email,
        school_type: this.school_type,
        resourcetype: this.resourcetype,
        riding: this.riding,
        sub_district_id: this.subdistrict,
        ballots: this.ballots,
        languagematerials: this.languagematerials,
        requireballot: this.requireballot,
        grades: this.grade_list,
        receive_info: this.receive_info.join(", ")
      };

      fetch(url, {
        method: "POST",
        body: JSON.stringify(payload),
        //headers: new Headers({
        //  'x-api-key': this.$TOKEN
        //})
      })
        .then((stream) => stream.json())
        .then((response) => {
          if (response.error) {
            //console.log("error");
            console.log(response.error);
          } else {
            console.log(response);
            if (callback != null) {
              callback();
            }
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log('ERROR getTableData: '+error)
        });
    },
    nextPrev(n) {
      var x = document.getElementsByClassName("tab");
      // Exit the function if any field in the current tab is invalid:
      if (n == 1 && !this.validateForm()) return false;
      // Hide the current tab:
      if (this.currentTab + n < x.length) {
        x[this.currentTab].style.display = "none";
      }
      // Increase or decrease the current tab by 1:
      this.currentTab = this.currentTab + n;

      var self = this;
      // if you have reached the end of the form...
      if (this.currentTab - n == 0 && this.currentDupe != 1) {
        // ... the form gets submitted:
        this.checkRegistration(function (res) {
          if (res.dupe == true) {
            self.$router.push({
              name: "error",
              params: { election_id: self.election_id, school: self.school },
            });
          } else {
            // console.log(this.school);
            if (self.school != -1) {
              self.getSchoolInfo(self.school);
            }
            self.showTab(self.currentTab);
          }
        });
        return false;
      } else if (this.currentTab >= x.length) {
        // ... the form gets submitted:
        this.submitRegistration(function () {
          console.log(self.$LANG);
          if (self.$LANG === "fr") {
            self.$router.push({
              name: "merci",
              params: { election_id: self.election_id },
            });
          } else {
            self.$router.push({
              name: "thankyou",
              params: { election_id: self.election_id },
            });
          }
        });
        return false;
      } else {
        this.showTab(this.currentTab);
      }
      // Otherwise, display the correct tab:
    },
    showTab(n) {
      // This function will display the specified tab of the form...
      var x = document.getElementsByClassName("tab");
      x[n].style.display = "block";
      //... and fix the Previous/Next buttons:

      if (n == 0) {
        document.getElementById("headingOne").style.display = "inline";
        document.getElementById("headingTwo").style.display = "inline";
        document.getElementById("headingThree").style.display = "inline";
      } else if (n == 1) {
        document.getElementById("headingOne").style.display = "none";
        document.getElementById("headingTwo").style.display = "inline";
        document.getElementById("headingThree").style.display = "inline";
      } else if (n == 2) {
        document.getElementById("headingOne").style.display = "none";
        document.getElementById("headingTwo").style.display = "none";
        document.getElementById("headingThree").style.display = "inline";
      }

      // if (n == 0) {
      //     document.getElementById("prevBtn").style.display = "none";
      // } else {
      //     document.getElementById("prevBtn").style.display = "inline";
      // }

      // if (n == (x.length - 1)) {
      //     document.getElementById("nextBtn").innerHTML = this.$i18n.t("Submit");
      // } else {
      //     document.getElementById("nextBtn").innerHTML = this.$i18n.t("Next");
      // }
      //... and run a function that will display the correct step indicator:
      this.fixStepIndicator(n);
    },
    fixStepIndicator(n) {
      // This function removes the "active" class of all steps...
      var i,
        x = document.getElementsByClassName("step");
      for (i = 0; i < x.length; i++) {
        x[i].className = x[i].className.replace(" active", "");
      }
      //... and adds the "active" class on the current step:
      x[n].className += " active";
    },
    validateForm() {
      // This function deals with validation of the form fields
      var x,
        y,
        i,
        valid = true;
      x = document.getElementsByClassName("tab");
      if (x[this.currentTab]) {
        y = x[this.currentTab].getElementsByTagName("input");
        // A loop that checks every input field in the current tab:
        for (i = 0; i < y.length; i++) {
          // If a field is empty...
          if (y[i].value == "" && y[i].className.includes("required")) {
            // add an "invalid" class to the field:
            y[i].className += " invalid";
            // and set the current valid status to false
            valid = false;
          }
        }

        y = x[this.currentTab].getElementsByTagName("select");
        // A loop that checks every input field in the current tab:
        for (i = 0; i < y.length; i++) {
          // If a field is empty...
          if (y[i].value == "" && y[i].className.includes("required")) {
            // add an "invalid" class to the field:
            y[i].className += " invalid";
            // and set the current valid status to false
            valid = false;
          }
        }

        if (this.currentTab == 1) {
          if (this.prov_short != "YT" && this.prov_short != 'PE') {
            if (this.resourcetype == "") {
              document.getElementById("resource_type").className += " invalid";
              valid = false;
            } else {
              document
                .getElementById("resource_type")
                .className.replace(" invalid", "");
            }
          }

          if (this.prov_short != 'PE') {
            if (this.languagematerials == "") {
              document.getElementById("languagematerials").className +=
                " invalid";
              valid = false;
            } else {
              document
                .getElementById("languagematerials")
                .className.replace(" invalid", "");
            }
          }

          if (this.language_correspondence == "") {
            document.getElementById("language_correspondence").className +=
              " invalid";
            valid = false;
          } else {
            document
              .getElementById("language_correspondence")
              .className.replace(" invalid", "");
          }

          if (this.been_team_lead == "") {
            document.getElementById("been_team_lead").className += " invalid";
            valid = false;
          } else {
            document
              .getElementById("been_team_lead")
              .className.replace(" invalid", "");
          }

          if (isNaN(parseInt(this.ballots))) {
            // console.log(document.getElementById("ballots"));
            document.getElementById("num_ballots").className += " invalid";
            valid = false;
          } else {
            document
              .getElementById("num_ballots")
              .className.replace(" invalid", "");
          }
        }
      }

      // If the valid status is true, mark the step as finished and valid:
      if (valid) {
        document.getElementsByClassName("step")[this.currentTab].className +=
          " finish";
      }
      return valid; // return the valid status
    },
  },
};
</script>